import { SitemapTemplates } from '@uno/common-shared';
export var sitemapIndexSchema = {
  type: 'object',
  properties: {
    groupKey: {
      type: 'string'
    },
    template: {
      "enum": Object.values(SitemapTemplates)
    },
    pageNumber: {
      type: 'number'
    },
    url: {
      type: 'string'
    }
  },
  required: ['groupKey', 'template', 'pageNumber', 'url'],
  additionalProperties: false
};
export var sitemapSchema = {
  type: 'object',
  properties: {
    groupKey: {
      type: 'string'
    },
    sortKey: {
      type: 'string'
    },
    template: {
      "enum": Object.values(SitemapTemplates)
    },
    pageNumber: {
      type: 'number'
    },
    id: {
      type: 'string'
    },
    url: {
      type: 'string'
    }
  },
  required: ['groupKey', 'sortKey', 'template', 'pageNumber', 'id', 'url'],
  additionalProperties: false
};